import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';
import Address from '../../../capabilities-react/gw-capability-fnol-common-react/models/Address';

export default class AddressLookupService {
    static getAddressFromLookup(selection, newAddress, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('addressLookup'),
            'getAddressFromLookup', [selection.addressKey, newAddress], additionalHeaders);
    }

    static addressLookup(newAddress, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('addressLookup'),
            'addressLookup', [newAddress], additionalHeaders);
    }
}
